import React, { useEffect } from "react";
import Select from "react-select";
import { LuSearch, LuMapPin } from "../../../public/assets/icons/vander";
import SearchHelper from "@/utils/SearchHelper";
import { useTranslations } from "@/TranslationContext";

const SellersSearchInputs = ({
  container,
  queryParams,
}: {
  container: "hero" | "sidebar";
  queryParams: any;
}) => {
  const [flatLocations, setFlatLocations] = React.useState([]);
  const [isLoadingLocation, setIsLoadingLocation] = React.useState(false);
  const [timerId, setTimerId] = React.useState<NodeJS.Timeout | null>(null);

  const [location, setLocation] = React.useState(null);
  const [query, setQuery] = React.useState("");
  const [orderBy, serOrderBy] = React.useState("relevance");

  const t = useTranslations();

  useEffect(() => {
    (async () => {
      setIsLoadingLocation(true);
      let locations = (await SearchHelper.getAllRegions())?.map((location) => {
        return {
          value: location.uuid,
          label: location.full_name,
        };
      });
      setFlatLocations(locations);
      setIsLoadingLocation(false);

      await setSelectedLocation(locations);
      setQuery(queryParams?.query);
      serOrderBy(queryParams?.orderBy);
    })();
  }, []);

  async function setSelectedLocation(locationsList: any[]) {
    let queryLocation = queryParams?.location;
    let currentLocation = locationsList.find(
      (location) => location.value == queryLocation
    );

    if (!currentLocation) {
      if (queryLocation) {
        currentLocation = await SearchHelper.getLocationByUuid(queryLocation);
        if (currentLocation) {
          let _currentLocation = {
            value: currentLocation.uuid,
            label: currentLocation.full_name,
          };
          locationsList.push(_currentLocation);
          setFlatLocations(locationsList);

          setLocation(_currentLocation);
        }
      }
    } else {
      setLocation(currentLocation);
    }
  }

  async function onLocationKeyDown(event: any): Promise<void> {
    let value = event.target.value;
    if (value.length < 1) {
      return;
    }
    setIsLoadingLocation(true);

    if (timerId) {
      clearTimeout(timerId);
    }

    let _timerId = setTimeout(async () => {
      setIsLoadingLocation(true);
      let locations = (
        await SearchHelper.getLocationByKeyword(event.target.value)
      )?.map((location) => {
        return {
          value: location.uuid,
          label: location.full_name,
        };
      });

      setIsLoadingLocation(false);
      setFlatLocations(locations);
    }, 1000);

    setTimerId(_timerId);
  }

  return (
    <form action="sellers">
      <input type="hidden" name="page" value={1} />
      <input type="hidden" name="orderBy" value={orderBy} />
      <div className="registration-form  text-start">
        <div className="md:flex gap-4">
          <div className="flex-1 ">
            <label className="form-label text-slate-900  font-medium">
              {t.searchKeywords}
            </label>
            <div className={"filter-search-form relative mt-2 "}>
              <LuSearch className="icons" />
              <input
                name="query"
                type="text"
                className="form-input filter-input-box bg-gray-50  border-0"
                placeholder=""
                value={query}
                onChange={(event) => {
                  setQuery(event.target.value);
                }}
              />
            </div>
          </div>
          <div className="flex-1">
            <label
              htmlFor="buy-properties"
              className="form-label text-slate-900  font-medium"
            >
              {t.location}
            </label>
            <div className={"filter-search-form relative mt-2 "}>
              <LuMapPin className=" icons" />
              <Select
                className="form-input filter-input-box bg-gray-50  border-0"
                options={flatLocations}
                name="location"
                isClearable={true}
                placeholder="eg. Kimara"
                isLoading={isLoadingLocation}
                onKeyDown={onLocationKeyDown}
                noOptionsMessage={() => {
                  return isLoadingLocation ? "Searching" : "Not found";
                }}
                value={location}
                onChange={(v: any) => {
                  setLocation(v);
                }}
              />
            </div>
          </div>
          <div className="mt-5">
            <div> &nbsp;</div>
            <button
              type="submit"
              name="search"
              className="btn cursor-pointer w-full bg-green-600 hover:bg-green-700 border-green-600 hover:border-green-700 text-white searchbtn submit-btn  rounded"
            >
              {t.search}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SellersSearchInputs;
